import request from '@/api';
const getUserId = () => {
  //获取本地存储的userId
  const userInfo = localStorage.getItem('userInfo');
  if (!userInfo) return '';
  const userInfoObj = JSON.parse(userInfo);
  return userInfoObj.userId;
};

const grammarToken = 'Bearer app-i7721zK0Fgzel8RJD2grGQa0';
export const fetchUpdateGrammar = async (params: any) => {
  const response = await fetch('/ai/v1/workflows/run', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': grammarToken,
    },
    body: JSON.stringify({
      ...params,
      user: getUserId(),
    }),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response;
};

const cozeToken = 'Bearer pat_lGliju4sSyssmolXRBpuLMiE4OfkC4wKvhzpwUidpr1zaKRF5L8MM1YSBvkN5kbh';
const cozeAppId = '7475168290869100585';

// 使用Coze API调用工作流
export const callCozeWorkflow = (params: any, workflowId: string) => {
  return fetch('https://api.coze.cn/v1/workflow/run', {
    method: 'POST',
    body: JSON.stringify({
      workflow_id: workflowId,
      parameters: params,
      is_async: false,
      app_id: cozeAppId,
    }),
    headers: {
      Authorization: cozeToken,
    },
  });
};

interface TranslateParams {
  text: string;
  source?: string;
  target: string;
}
// 翻译
export const translate = (params: TranslateParams) => {
  return request.post('/app/translate/translation', params);
};

// 获取语言字典
export const fetchLanguageList = () => {
  return request.post('/app/sysDict/getAppSysDictList', { dictCode: 'translate_lang' });
};

